import axios from '@/axios'
import { $localStorage } from '@/plugins/edunix'
import md5 from 'md5'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		user: {},
		authenticated: false,
	},

	actions: {
		login({ commit }, { centerId, username, password, isMD5 = false }) {
			const passwordMD5 = isMD5 ? password : md5(password);
			return axios.post(`/center/${centerId}/user/${username}/auth`, null, {
				headers: { 'x-password': passwordMD5 }
			}).then(({ data }) => {
				$localStorage.centerId = centerId;
				$localStorage.username = username;
				$localStorage.password = passwordMD5;
				axios.defaults.headers.common['x-password'] = passwordMD5;
				commit(types.LOGIN, data)
			})
		},
		logout({ commit }) {
			commit(types.LOGOUT);
		}
	},

	mutations: {
		[types.LOGIN](state, data) {
			state.user = data;
			localStorage.setItem('auth', JSON.stringify(data));
			state.authenticated = true;
		},
		[types.LOGOUT](state) {
			state.authenticated = false;
			$localStorage.centerId = null;
			$localStorage.username = null;
			$localStorage.password = null;
			localStorage.removeItem('auth');
			state.user = {};
			delete axios.defaults.headers.common['x-password'];
		}
	},

	getters: {
		
	}
}